import { Injectable, Type } from '@angular/core';
import { TemplatePlaceHolderControlModel } from './template-placeholder-control.model';
import { FiDocumentTemplateItemViewBase } from '../document-template/document-template-item-view/document-template-item-view-base';
import { ITemplatePlaceHolderControlContent } from '@fi-app/template/template';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { TemplateControlType } from '@fi-app/template/types/template-control-type';

export interface IDocumentTemplateBaseItem {
    model: TemplatePlaceHolderControlModel;
    controlId?: TemplateControlType;
}

/*
export interface IBaseItemModel {
    Contents: ITemplatePlaceHolderControlContent[];
    MediaBankFileReferences: IMediaBankFileReference[];
    Settings: {
        lock: boolean;
        Columns;
        SortOrder: number;
        columnClass?: string;
    };
}
*/

@Injectable()
export class BaseItemModelService {
    type: any;
    viewComponent: Type<FiDocumentTemplateItemViewBase>;
    optionComponent: Type<any>;
    textId: string;
    initInstance: (instance: BaseItemModelService) => void;
    controlId: number;
    config: {
        COLUMNS: { ONE: { id: number; name: string }; TWO: { id: number; name: string } };
        COLUMNS_CLASSES: ({ id: number; title: string } | { id: number; title: string; cssClass: string })[];
    };
    private iconClass: any;
    EditColumn: number;

    model: TemplatePlaceHolderControlModel;
    isLocked: () => boolean;

    IsEmpty(contentLanguageId) {
        return true;
    }

    constructor(private customerDataService: FiCustomerDataService) {}

    init(
        type,
        id,
        viewComponent: Type<FiDocumentTemplateItemViewBase>,
        optionComponent: Type<any>,
        textId: string,
        iconClass: string,
        initInstance?,
    ) {
        this.type = type;
        this.viewComponent = viewComponent;
        this.optionComponent = optionComponent;
        this.textId = textId;
        this.iconClass = iconClass;
        this.initInstance = initInstance;
        this.controlId = id;

        this.config = {
            COLUMNS: {
                ONE: {
                    id: 1,
                    name: 'template.one_column',
                },
                TWO: {
                    id: 2,
                    name: 'template.two_column',
                },
            },
            COLUMNS_CLASSES: [
                {
                    id: 0,
                    title: 'Two columns 50x50',
                },
                {
                    id: 1,
                    title: 'Two columns 30x30',
                    cssClass: 'columns-30-70',
                },
                {
                    id: 2,
                    title: 'Two columns 70x30',
                    cssClass: 'columns-70-30',
                },
            ],
        };
        this.isLocked = function () {
            return this.model.Settings && this.model.Settings.lock === true;
        };
    }

    create(): BaseItemModelService {
        var newObject = <BaseItemModelService>{};
        Object.assign(newObject, this);
        newObject.EditColumn = undefined;
        newObject.model = new TemplatePlaceHolderControlModel(this.customerDataService.customerData, {
            ControlId: this.controlId,
        });
        newObject.model.Settings.lock = false;
        newObject.model.Settings.Columns = this.config.COLUMNS.ONE.id;

        if (this.initInstance) {
            this.initInstance(newObject);
        }

        return newObject;
    }
}
